module.exports = __webpack_public_path__ + "static/media/wordpress.61479008.svg";